"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserInChatMode = void 0;
function isUserInChatMode(user) {
    return user.chat_mode === 'STRICT' || user.chat_mode === 'FLEXIBLE';
}
exports.isUserInChatMode = isUserInChatMode;
